var _jsxFileName = "/var/home/clovis/Documents/Mangane/app/soapbox/components/helmet.tsx";
import * as React from 'react';
import { Helmet as ReactHelmet } from 'react-helmet';
import { useAppSelector, useSettings } from 'soapbox/hooks';
import FaviconService from 'soapbox/utils/favicon_service';
FaviconService.initFaviconService();
const getNotifTotals = state => {
  const notifications = state.notifications.unread || 0;
  const reports = state.admin.openReports.count();
  const approvals = state.admin.awaitingApproval.count();
  return notifications + reports + approvals;
};
const Helmet = ({
  children
}) => {
  const title = useAppSelector(state => state.instance.title);
  const unreadCount = useAppSelector(state => getNotifTotals(state));
  const demetricator = useSettings().get('demetricator');
  const hasUnreadNotifications = React.useMemo(() => !(unreadCount < 1 || demetricator), [unreadCount, demetricator]);
  const addCounter = string => {
    return hasUnreadNotifications ? `(${unreadCount}) ${string}` : string;
  };
  const updateFaviconBadge = () => {
    if (hasUnreadNotifications) {
      FaviconService.drawFaviconBadge();
    } else {
      FaviconService.clearFaviconBadge();
    }
  };
  React.useEffect(() => {
    updateFaviconBadge();
  }, [unreadCount, demetricator]);
  return /*#__PURE__*/React.createElement(ReactHelmet, {
    titleTemplate: addCounter(`%s | ${title}`),
    defaultTitle: addCounter(title),
    defer: false,
    __self: this,
    __source: {
      fileName: _jsxFileName,
      lineNumber: 41,
      columnNumber: 5
    }
  }, children);
};
export default Helmet;